import { RouteRecordRaw } from "vue-router";

import { ROLES_AND_PERMISSION_ON_ROUTES } from "@/core/configs/rolesAndPermissionsMappingOnRoutes";
import { PATH } from "@/core/constants/path";

const routes: Array<RouteRecordRaw> = [
  {
    path: PATH.SALES_SNAPSHOT,
    name: "salesSnapshot",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.SALES_SNAPSHOT.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.SALES_SNAPSHOT.PERMISSIONS,
    },
    component: () => import("@/modules/Snapshots/views/SalesSnapshot.vue"),
  },
  {
    path: PATH.DAILY_ISSUANCE,
    name: "dailyIssuance",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.DAILY_ISSUANCE.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.DAILY_ISSUANCE.PERMISSIONS,
    },
    component: () => import("@/modules/Snapshots/views/DailyIssuances.vue"),
  },
  {
    path: PATH.DIGITAL_PAYMENTS,
    name: "digitalPayments",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.DIGITAL_PAYMENTS_BY_SECTORS.ROLES,
      permissions:
        ROLES_AND_PERMISSION_ON_ROUTES.DIGITAL_PAYMENTS_BY_SECTORS.PERMISSIONS,
    },
    component: () => import("@/modules/Snapshots/views/DigitalPayments.vue"),
  },
  {
    path: PATH.ORGANIZATION_SNAPSHOT,
    name: "organizationSnapshot",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.ORGANIZATION_SNAPSHOT.ROLES,
      permissions:
        ROLES_AND_PERMISSION_ON_ROUTES.ORGANIZATION_SNAPSHOT.PERMISSIONS,
    },
    component: () =>
      import("@/modules/Snapshots/views/OrganizationSnapshot.vue"),
  },
  {
    path: PATH.SECTOR_SNAPSHOT,
    name: "sectorSnapshot",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.SECTOR_SNAPSHOT.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.SECTOR_SNAPSHOT.PERMISSIONS,
    },
    component: () => import("@/modules/Snapshots/views/SectorSnapshot.vue"),
  },
];

export default routes;
